import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BACKGROUND from "../assets/images/aboutbackground.png";
import AboutCard from "../components/AboutCard";
import Background1 from "../assets/images/background1.png";
import Background2 from "../assets/images/background2.png";
import Background3 from "../assets/images/background3.png";
import Background4 from "../assets/images/background4.png";
import Background5 from "../assets/images/background5.png";
import Background6 from "../assets/images/background6.png";
import Logo1 from "../assets/images/logo1.png";
import Logo2 from "../assets/images/logo2.png";
import Logo3 from "../assets/images/logo3.png";
import Logo4 from "../assets/images/logo4.png";
import Logo5 from "../assets/images/logo5.png";
import Logo6 from "../assets/images/logo6.png";

const About = () => {
  return (
    <div className="w-full">
      <Navbar />

      {/* Background Image Section */}
      <div className="w-full">
        <img
          src={BACKGROUND}
          alt="Background"
          className="w-full h-[50vh] object-cover"
        />
      </div>

      {/* Services Section */}
      <div className="w-full bg-[#F8F8F8] flex flex-col justify-center items-center py-10 px-4 md:px-8 lg:px-16">
        <button
          type="button"
          className="bg-[#DBBDC1] px-6 py-2 text-[#75000e] font-semibold rounded-full shadow-md mt-4"
        >
          Our Services
        </button>

        <h2 className="text-2xl md:text-3xl font-serif text-[#000000] text-center mt-6 md:mt-8">
          Our Services for Employers
        </h2>

        <p className="max-w-4xl text-center text-[#000000] font-serif leading-7 md:leading-8 mt-4 text-sm md:text-base">
          At Globelink, we understand the importance of hiring the right talent.
          We work closely with you to understand your organization's unique
          requirements and source candidates who will thrive in your corporate
          environment. Our services include:
        </p>

        {/* Responsive Grid Layout for About Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12 w-full max-w-[1200px] mt-10 md:mt-16 lg:mt-20">
          <AboutCard
            bgImage={Background1}
            logo={Logo1}
            heading="Candidate Screening & Shortlisting"
            content="We conduct a thorough evaluation of potential candidates, ensuring their skills, experience, and values align with your organizational needs."
          />

          <AboutCard
            bgImage={Background2}
            logo={Logo2}
            heading="Temporary and Permanent Staffing Solutions"
            content="We conduct a thorough evaluation of potential candidates, ensuring their skills, experience, and values align with your organizational needs."
          />

          <AboutCard
            bgImage={Background3}
            logo={Logo3}
            heading="Executive Search"
            content="For senior management roles, we leverage our network and industry expertise to identify and recruit top-tier executives."
          />
        </div>

        {/* Charges Information */}
        {/* <p className="w-full max-w-7xl mt-8 px-4 md:px-6 text-sm md:text-base text-center leading-6 md:leading-7">
          <span className="text-[#75000e] font-semibold">
            Charges for Companies:
          </span>{" "}
          Our recruitment fees are calculated based on the candidate's salary
          package. Our charges typically range from Rs. 10,000 to Rs. 20,000 per
          placement, depending on the candidate’s salary. This fee is applicable
          once the candidate has successfully joined your organization. We
          ensure transparency in our pricing and offer flexible payment options.
        </p> */}
      </div>

      <div className="w-full bg-[#F8F8F8] flex flex-col justify-center items-center py-10 px-4 md:px-8 lg:px-16">
        <h2 className="text-2xl md:text-3xl font-serif text-[#000000] text-center mt-6 md:mt-8">
          Our Services for Job Seekers
        </h2>

        <p className="max-w-4xl text-center text-[#000000] font-serif leading-7 md:leading-8 mt-4 text-sm md:text-base">
          Looking for a job can be a daunting experience, but at Globelink
          Techservices OPC PVT.LTD, we simplify the process. Our recruitment
          consultants are here to guide you through every step, from finding the
          right job to securing your dream position. We:
        </p>

        {/* Responsive Grid Layout for About Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12 w-full max-w-[1200px] mt-10 md:mt-16 lg:mt-20">
          <AboutCard
            bgImage={Background4}
            logo={Logo4}
            heading="Personalized Job Search"
            content="We conduct a thorough evaluation of potential candidates, ensuring their skills, experience, and values align with your organizational needs"
          />

          <AboutCard
            bgImage={Background5}
            logo={Logo5}
            heading="Interview Preparation"
            content="We conduct a thorough evaluation of potential candidates, ensuring their skills, experience, and values align with your organizational needs"
          />

          <AboutCard
            bgImage={Background6}
            logo={Logo6}
            heading="Career Counseling"
            content="For senior management roles, we leverage our network and industry expertise to identify and recruit top-tier executives."
          />
        </div>

        {/* Charges Information */}
        {/* <p className="w-full max-w-7xl mt-8 px-4 md:px-6 text-sm md:text-base text-center leading-6 md:leading-7">
          <span className="text-[#75000e] font-semibold">
            Charges for Companies:
          </span>{" "}
          Our recruitment fees are calculated based on the candidate's salary
          package. Our charges typically range from Rs. 10,000 to Rs. 20,000 per
          placement, depending on the candidate’s salary. This fee is applicable
          once the candidate has successfully joined your organization. We
          ensure transparency in our pricing and offer flexible payment options.
        </p> */}
      </div>

      <Footer />
    </div>
  );
};

export default About;
